import { ViewValues } from '@g17eco/types/surveyOverview';
import { SurveyDelegationProps } from './types';
import { UsersView } from './users/UsersView';
import { WorkgroupsView } from './workgroups/WorkgroupsView';
import NotFound from '@g17eco/atoms/not-found';

export const SurveyDelegation = ({
  view,
  onChangeView,
  utrvIds,
  survey,
  isReadOnly,
  metricGroups,
}: SurveyDelegationProps) => {
  switch (view) {
    case ViewValues.Users:
      return (
        <UsersView view={view} onChangeView={onChangeView} utrvIds={utrvIds} survey={survey} isReadOnly={isReadOnly} />
      );
    case ViewValues.Workgroups:
      return (
        <WorkgroupsView
          view={view}
          onChangeView={onChangeView}
          survey={survey}
          metricGroups={metricGroups}
          utrvIds={utrvIds}
        />
      );
    default:
      return <NotFound />;
  }
};
